import React from 'react';

export const AlertIcon: React.FC = () => (
    <svg className="w-5 h-5 text-yellow-400" fill="currentColor" viewBox="0 0 20 20">
      <path
        fillRule="evenodd"
        d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.216 3.031-1.742 3.031H4.42c-1.526 0-2.492-1.697-1.742-3.031l5.58-9.92zM10 13a1 1 0 110-2 1 1 0 010 2zm-1-8a1 1 0 011-1h.01a1 1 0 110 2H10a1 1 0 01-1-1z"
        clipRule="evenodd"
      />
    </svg>
);

interface CheckIconProps {
    className: string;
}

export const CheckIcon: React.FC<CheckIconProps> = ({ className }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
    </svg>
);

// ── Bottom-nav icons ──────────────────────────────────────────────────────────

export const NavHomeIcon: React.FC = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M3 12L5 10M5 10L12 3L19 10M5 10V20C5 20.5523 5.44772 21 6 21H9M19 10L21 12M19 10V20C19 20.5523 18.5523 21 18 21H15M9 21C9.55228 21 10 20.5523 10 20V16C10 15.4477 10.4477 15 11 15H13C13.5523 15 14 15.4477 14 16V20C14 20.5523 14.4477 21 15 21M9 21H15" stroke="#1E5E5B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
export const NavRedFlagsIcon: React.FC = () => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    width="24" 
    height="24" 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="#1E5E5B" // Change this from currentColor back to the green hex
    strokeWidth="1.5" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <path d="M6 22V2.8a.8.8 0 0 1 1.17-.71l11.38 5.69a.8.8 0 0 1 0 1.44L6 15.5"/>
  </svg>
);
export const NavRecoveryIcon: React.FC = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M12.007 21.274L2.57511 12.7306C-2.55093 7.60453 4.98435 -2.23747 12.007 5.72498C19.0297 -2.23747 26.5308 7.6387 21.4389 12.7306L12.007 21.274Z" stroke="#1E5E5B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M13.4194 8.1687H10.58V10.5803H8.16846V13.4197H10.58V15.8313H13.4194V13.4197H15.831V10.5803H13.4194V8.1687Z" stroke="#1E5E5B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const NavJournalIcon: React.FC = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M16 8L2 22M17.5 15H9M20.24 12.24C21.3658 11.1142 21.9983 9.58722 21.9983 7.99504C21.9983 6.40285 21.3658 4.87588 20.24 3.75004C19.1142 2.62419 17.5872 1.9917 15.995 1.9917C14.4028 1.9917 12.8758 2.62419 11.75 3.75004L5 10.5V19H13.5L20.24 12.24Z" stroke="#1E5E5B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const NavGPSummaryIcon: React.FC<{ locked?: boolean }> = ({ locked }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={locked ? "#9CA3AF" : "#1E5E5B"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2" />
    <rect x="9" y="3" width="6" height="4" rx="1" />
    <path d="M9 12h6M9 16h4" />
  </svg>
);

export const NavProfileIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M12.1359 2.25017C6.65243 2.17611 2.17587 6.65267 2.24993 12.1361C2.32305 17.395 6.60509 21.677 11.864 21.7502C17.3484 21.8252 21.824 17.3486 21.749 11.8652C21.6768 6.60533 17.3948 2.3233 12.1359 2.25017ZM18.0618 17.59C18.0431 17.6102 18.0202 17.626 17.9948 17.6364C17.9693 17.6468 17.9418 17.6514 17.9144 17.65C17.8869 17.6485 17.8601 17.6411 17.8358 17.6281C17.8116 17.6152 17.7905 17.597 17.774 17.575C17.3547 17.0265 16.8413 16.5568 16.2576 16.188C15.0641 15.422 13.552 15.0002 11.9999 15.0002C10.4479 15.0002 8.93571 15.422 7.74227 16.188C7.15862 16.5566 6.64516 17.0261 6.22587 17.5745C6.20939 17.5966 6.18828 17.6147 6.16402 17.6277C6.13976 17.6406 6.11294 17.6481 6.08548 17.6495C6.05801 17.6509 6.03057 17.6463 6.00509 17.6359C5.97961 17.6256 5.95673 17.6097 5.93805 17.5895C4.56259 16.1047 3.78344 14.1645 3.74993 12.1408C3.67352 7.57939 7.41649 3.76142 11.9798 3.75017C16.5431 3.73892 20.2499 7.44439 20.2499 12.0002C20.2515 14.0727 19.4699 16.0693 18.0618 17.59Z" fill="#1E5E5B" />
    <path d="M12 6.75C11.0756 6.75 10.2398 7.09641 9.6459 7.72594C9.05199 8.35547 8.75527 9.22594 8.82231 10.1602C8.95824 12 10.3837 13.5 12 13.5C13.6162 13.5 15.0389 12 15.1776 10.1606C15.247 9.23531 14.9526 8.37281 14.3489 7.73156C13.7526 7.09875 12.9182 6.75 12 6.75Z" fill="#1E5E5B" />
  </svg>
);
